import ListPageView from "../../components/ListPageView"

export default function VolunteerActivityLog() {
  const ID_TEMPLATE = "volunteer_activity_log"
  const ID_BLOCKS = [
    "activity__volunteer_log",
    "activity",
    "default__custom__block_1",
  ]

  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
    {
      header: "Volunteer Activity",
      field: "volunteer_log_activities|volunteer_log_activities_other_type",
      block: "activity__volunteer_log",
      type: "concatenation",
    },
    {
      header: "Location",
      field: "activity__location_ids",
      block: "activity",
      type: "location",
    },
    {
      header: "Program ID",
      field: "activity__program_identity_ids",
      block: "activity",
      type: "program",
    },
  ]

  return (
    <div className="main-content">
      <ListPageView
        idTemplate={ID_TEMPLATE}
        idBlocks={ID_BLOCKS}
        columns={listViewCols}
      />
    </div>
  )
}
